import { useMemo } from "react";
import { useSelector } from "react-redux";
import {
  selectConsolidatedAccountsPortfolioData,
  selectPortfolioData,
} from "@shared/slices/portfolio.slice.ts";
import { dashboardFilters } from "@shared/slices/filters.slice";
import { dedupeAccountsData } from "@shared/features/portfolio/utils.ts";
import { getUniqueAccounts } from "features/dashboard/common/utils";

/**
 * The new-look dashboard's accounts: those in the dashboard's account filter
 * (every account until the filter loads, as with the balance history), each
 * counted once, so the headline, the history and the allocation agree.
 */
const useDashboardAccounts = () => {
  const accountsData = useSelector(selectConsolidatedAccountsPortfolioData);
  const portfolioData = useSelector(selectPortfolioData);
  const clientsFilter = useSelector(
    dashboardFilters.selectors.selectClientsFilter
  );
  const exchangeToClients = useSelector(
    dashboardFilters.selectors.selectExchangeToClientsMapping
  );
  return useMemo(() => {
    const inFilter = clientsFilter.length
      ? accountsData.filter(
          (account) =>
            clientsFilter.includes(account.client) &&
            !!exchangeToClients[account.exchange]?.includes(account.client)
        )
      : accountsData;
    // Linked accounts once (as selectUniqueAccountsPortfolioData), then each
    // client uuid once (as getAccountsTotals).
    return getUniqueAccounts(
      dedupeAccountsData(inFilter, portfolioData?.client_dependency_new)
    );
  }, [accountsData, portfolioData, clientsFilter, exchangeToClients]);
};

export default useDashboardAccounts;
